import AxiosAPI from "./AxiosAPI"

export const fetchTaxes=async ()=>{
    try{
        const response=await AxiosAPI.get("/setup/taxes")
        return response.data
    }catch(error){
        console.log(error, "while fetching the taxes")
        throw error.response?.data || error; 
    }
}



export const handleAddTax = async (data) => {
  try {
    const response = await AxiosAPI.post("/setup/taxes", data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("Response from add tax s:", response);
    return response.data;
  } catch (error) {
    console.error("API Error:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const handleEditTax= async (data) => {  
  try {
    const response = await AxiosAPI.put(
      `/setup/taxes/${data.key}`,
      data,{
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const deleteTax = async (key) => { 
  try {
    const response = await AxiosAPI.delete(
      `/setup/taxes/${key}`
    );
    return response.data;
  } catch (err) {
    console.log(err);
    
  }
};
